import gia from '@publicAssets/images/ui/diamond-view/sq_gia.png'
import igi from '@publicAssets/images/ui/diamond-view/sq_igi.png'
import gcal from '@publicAssets/images/ui/diamond-view/sq_gcal.png'

export const diamondLabIcons = {
  GIA: gia,
  IGI: igi,
  GCAL: gcal,
}

export const getDiamondLabIcon = (lab: string) => {
  return diamondLabIcons[lab as keyof typeof diamondLabIcons]
}

export const trimFileName = (str: string) => {
  return str.split('/').slice(-1).toString()
}

/**
 *
 * @param lab Diamond lab
 * @param certnum Diamond certificate number
 * @returns This function generates the certificate URL in case the diamond.certurl_local is NULL (this should not happen)
 */
export const generateCertUrl = (lab: string, certnum: string | null) => {
  if (!certnum) {
    return ''
  }

  switch (lab.toUpperCase()) {
    case 'GIA':
      return `https://www.gia.edu/report-check?reportno=${certnum}`
    case 'IGI':
      return `https://www.igi.org/verify-your-report/?r=${certnum}`
    case 'GCAL':
      return `https://www.gcalusa.com/certificate-search.html?certificate_id=${certnum}`
    default:
      return ''
  }
}
